import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../components/loading/Loading";
import MainContainer from "../../components/container/MainContainer";
import TextContainer from "../../components/text/TextContainer";
import Modal from "../../components/modal/Modal";
import { openModal } from "../../features/modalSLice";
import UpdateProfile from "./UpdateProfile";
import ChangePassword from "./ChangePassword";

const Profile = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userInfo);
  const loading = useSelector((state) => state.user.getLoggedInUser);
  const color = useSelector((state) => state.user.color);
  const modalContent = useSelector((state) => state.modal.content);

  const onOpenUpdateProfileModal = () => {
    dispatch(openModal(<UpdateProfile id={user.id} />));
  };

  const onOpenChangePasswordModal = () => {
    dispatch(openModal(<ChangePassword id={user.id} />));
  };

  if (loading || !user.id) {
    return <Loading />;
  }
  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <div>
        <div
          className={`w-36 h-36 mx-auto rounded-full ${color} flex justify-center items-center text-text-gen/80 text-5xl`}
        >
          {`${user.first_name[0]}${user.last_name[0]}`}
        </div>
      </div>
      <div className=" sm:flex h-full text-text-1/80 pb-10">
        <div className="flex-1 sm:h-full pt-5 px-3">
          <div className="bg-content border border-bkg2 p-4   mt-7 rounded-md">
            <h5 className="text-text-1/90">{`${user.first_name} ${
              user.other_names ? user.other_names + " " : ""
            }${user.last_name}`}</h5>
            <TextContainer label="Email" content={user.email} />
            <TextContainer label="Phone" content={user.phone} />
            <TextContainer label="Mobile" content={user.phone2} />
            <TextContainer label="Role" content={user.role} />
            <TextContainer label="Department" content={user.department} />
            <TextContainer
              label="Community"
              content={
                user.communities.length > 0 ? user.communities[0].name : "N/A"
              }
            />

            <TextContainer label="Province" content={user.province.name} />
            <TextContainer label="Country" content={user.country.name} />
          </div>
          <div className="border border-bkg2 p-4   mt-7 rounded-md">
            <TextContainer label="Gender" content={user.gneder} />
            <TextContainer label="Verified" content={user.verified || "True"} />
            <TextContainer
              label="Joined On"
              content={new Date(user.created_at).toDateString()}
            />
          </div>
        </div>
        <div className=" flex-1  mt-5 sm:mt-0  sm:h-full rounded-md pt-5 px-3">
          {/* Edit User */}
          <div className="mt-7 border border-bkg2 -2 p-5">
            <p className="py-5 text-justify">
              Update your profile with all the required information.
            </p>
            {!user.phone && <p>* Please update your phone number</p>}
            {!user.phone2 && <p>* Please update your second phone Number</p>}
            {!user.gender && <p>* Please update your gender </p>}
            <button
              onClick={onOpenUpdateProfileModal}
              className="add-rss-btn mt-5"
            >
              Update Profile
            </button>
          </div>
          {/* Change Password */}
          <div className="mt-7 border border-bkg2 -2 p-5">
            <p className="py-5 text-justify">
              Please change your password if you suspect irregular activities or
              your account has just been created!
            </p>
            <button
              onClick={onOpenChangePasswordModal}
              className="add-rss-btn mt-5"
            >
              Change Password
            </button>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default Profile;
